<footer class="footer">
  <div class="footer-content">
    <span>Last update: {{ lastUpdate }}</span>
    <span class="separator">|</span>
    <span>&copy; {{ currentYear }} Chevron Corporation</span>
    <span class="separator">|</span>
    <span>Company Confidential</span>
  </div>
  <div class="footer-links">
    <span>Content contact: <a href="#">LogMerge Team</a></span>
    <span class="separator">|</span>
    <span>Technical contact: <a href="#">LogMerge Team</a></span>
  </div>
</footer>
